import { render, staticRenderFns } from "./UserAndCompanyInfoStep.component.vue?vue&type=template&id=468c3412&scoped=true"
import script from "./UserAndCompanyInfoStep.component.vue?vue&type=script&lang=js"
export * from "./UserAndCompanyInfoStep.component.vue?vue&type=script&lang=js"
import style0 from "./UserAndCompanyInfoStep.component.vue?vue&type=style&index=0&id=468c3412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c3412",
  null
  
)

export default component.exports